import { useMemo } from 'react';
import { TagColored } from '@spark';
import { toolCallCounts, toolTagVariant, trajectoryMessages } from './trajectoryView';
import './ToolsCalledCell.css';

/**
 * TOOLS CALLED column cell (Figma 3966:24237): one Spark `TagColored`
 * `name() (count)` per distinct tool, stacked with a 12px gap in first-call
 * order.
 *
 * Colors come from `variantByName` (tool → variant, built once per tab from
 * the sorted distinct-tool list, see `toolTagVariantsByName`) so a tool is the
 * same color in every row and in the column's filter menu. A tool missing from
 * the map — e.g. uploaded after the tab's list was fetched — falls back to the
 * Figma pink → blue → lime sequence by its position in the row.
 */
export function ToolsCalledCell({ record, variantByName }) {
    const counts = useMemo(() => toolCallCounts(trajectoryMessages(record)), [record]);

    if (counts.length === 0) {
        return <span className="agentic-tools-called-cell__empty">No tools called</span>;
    }

    return (
        <div className="agentic-tools-called-cell" data-testid="agentic-tools-called">
            {counts.map(({ name, count }, index) => (
                <TagColored
                    key={name}
                    label={`${name}() (${count})`}
                    variant={variantByName?.get?.(name) ?? toolTagVariant(index)}
                />
            ))}
        </div>
    );
}

export default ToolsCalledCell;
